import { push } from 'connected-react-router';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { EnvironmentApi } from 'vrlcm-gui-api';
import { EnvironmentRequest, EnvironmentRequestProduct } from 'vrlcm-gui-types';
import {
  GenerateUpgradeProductRequest,
  generateUpgradeProductRequestFailed,
  generateUpgradeProductRequestSuccess
} from '../../actions/Environments';
import {
  InitializeUpgradeWorkflow,
  initializeUpgradeWorkflowFailed,
  initializeUpgradeWorkflowSuccess,
  SaveUpgradeWorkflow,
  saveUpgradeWorkflowFailed,
  saveUpgradeWorkflowSuccess,
  SubmitUpgradeWorkflow,
  submitUpgradeWorkflowFailed,
  submitUpgradeWorkflowSuccess
} from '../../actions/workflows/UpgradeWorkflow';
import EnvironmentWorkflowAPI from '../../api/workflows/EnvironmentWorkflow';
import UpgradeWorkflowAPI from '../../api/workflows/UpgradeWorkflow';
import * as Constants from '../../constants/action-constants';
import { BASE_ROUTE, ROUTES } from '../../constants/RouteConstants';
import { updateParentEnvironment } from './util';

function* generateUpgradeProductRequest(action: GenerateUpgradeProductRequest) {
  try {
    const { updatedEnvironment, upgradeState } = action.payload;
    const { requestId } = upgradeState;
    yield call(
      EnvironmentWorkflowAPI.patchCreateEnvironmentDetails,
      updatedEnvironment
    );
    yield call(UpgradeWorkflowAPI.patchUpgradeDetails, upgradeState);
    yield put(generateUpgradeProductRequestSuccess(upgradeState));
    yield put(push(`${ROUTES.UPGRADE_PRODUCT}/${requestId}`));
  } catch (e) {
    yield put(generateUpgradeProductRequestFailed());
  }
}

function* watchForGenerateUpgradeProductRequest() {
  yield takeLatest(
    Constants.GENERATE_UPGRADE_PRODUCT_REQUEST,
    generateUpgradeProductRequest
  );
}

function* initializeWorkflow(action: InitializeUpgradeWorkflow) {
  try {
    const { requestId } = action.payload;
    if (!requestId) {
      throw Error('400');
    }
    let existingVidm: EnvironmentRequestProduct | undefined;
    try {
      const globalenvironment: EnvironmentRequest = yield call(
        EnvironmentApi.getEnvironmentRequestById,
        'globalenvironment'
      );
      existingVidm = globalenvironment.products.find(p => p.id === 'vidm');
    } catch (e) {
      existingVidm = undefined;
    }
    const state = yield call(UpgradeWorkflowAPI.getUpgradeState, requestId);
    yield put(initializeUpgradeWorkflowSuccess(state, existingVidm));
  } catch (e) {
    yield put(initializeUpgradeWorkflowFailed());
    if (e.message === '400') {
      yield put(push(ROUTES.PAGE_UNKNOWN));
    }
  }
}

function* watchForInitailizeWorkflow() {
  yield takeLatest(Constants.INITIALIZE_UPGRADE_WORKFLOW, initializeWorkflow);
}

function* saveUpgradeWorkflow(action: SaveUpgradeWorkflow) {
  try {
    const { state, exit } = action.payload;
    yield call(UpgradeWorkflowAPI.patchUpgradeDetails, state);
    yield put(saveUpgradeWorkflowSuccess(state));
    if (exit) {
      yield put(push(BASE_ROUTE));
    }
  } catch (e) {
    yield put(saveUpgradeWorkflowFailed());
  }
}

function* watchForSaveWorkflow() {
  yield takeLatest(Constants.SAVE_UPGRADE_WORKFLOW, saveUpgradeWorkflow);
}

function* submitUpgradeWorkflow(action: SubmitUpgradeWorkflow) {
  try {
    const { state } = action.payload;
    yield call(UpgradeWorkflowAPI.patchUpgradeDetails, state);
    const productId = state.upgradeProductRequestDTO.productId;
    yield updateParentEnvironment(state.uiData, 'upgrade-product', productId);
    yield put(submitUpgradeWorkflowSuccess());
    yield put(push(`${ROUTES.REQUESTS}/${state.requestId}`));
  } catch (e) {
    yield put(submitUpgradeWorkflowFailed());
  }
}

function* watchForSubmitWorkflow() {
  yield takeLatest(Constants.SUBMIT_UPGRADE_WORKFLOW, submitUpgradeWorkflow);
}

export default function* upgradeWorkflowSaga() {
  yield all([
    watchForGenerateUpgradeProductRequest(),
    watchForInitailizeWorkflow(),
    watchForSaveWorkflow(),
    watchForSubmitWorkflow()
  ]);
}
